import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { IonSlides } from "@ionic/angular";
import { ViewportScroller } from '@angular/common';

import { CheckTokenService } from "../auth-guard/check-token.service";
import { AuthenticationService } from "../authentication/authentication.service";
import { AnnouncementModel } from "../pre-lottery/models/announcment.model";
import { PreLotteryApplicationService } from "../pre-lottery/services/pre-lottery-application.service";
import { QuestionAnswerService } from "../question-answer/question-answer.service";
import { YoutubeHelpVideoComponent } from "../question-answer/youtube-help-video/youtube-help-video.component";
import { SharedService } from "../toolbar/shared.service";
import { LandingPopupComponent } from "./landing-popup/landing-popup.component";
import { BannerImageModel } from "../registration-step/models/banner-image.model";
import {GoLiveService} from "../pre-lottery/services/shared-go-live.service";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.scss"],
})
export class LandingComponent implements OnInit, AfterViewInit {
  @ViewChild("Slides") slides: IonSlides | any;
  @ViewChild("SlidesXl") slidesXl: IonSlides | any;
  @ViewChild("VideoSlides") videoSlides: IonSlides | any;
  @ViewChild("VideoSlidesLargeScreen") videoSlidesLargeScreen: IonSlides | any;

  news: AnnouncementModel[] = [];
  videos: any[] = [];
  isDownloadAppButtonVisible: boolean = false;
  banners: BannerImageModel[] = [];
  activeLangIndex: number = 0;
  lang: string = "";


  slideOpts = {
    initialSlide: 0,
    speed: 400,
    spaceBetween: 15,
    autoplay: {
      delay: 6000,
    },
  };

  videoSlideOpts = {
    slidesPerView: 3,
    initialSlide: 0,
    speed: 400,
    loop: false,
    spaceBetween: 15,
  };

  constructor(
    private router: Router,
    private preLotteryApplicationService: PreLotteryApplicationService,
    private dialog: MatDialog,
    private sharedService: SharedService,
    private authService: CheckTokenService,
    private authenticationService: AuthenticationService,
    protected _sanitizer: DomSanitizer,
    private questionAnswerService: QuestionAnswerService,
    private route: ActivatedRoute,
    private viewportScroller: ViewportScroller,
    private goLiveService: GoLiveService,
  ) { }

  ngOnInit() {
    // if (false){
      this.checkActiveLanguage();
    if (
      window.location.href.startsWith("http://103.11.152.158:46/") ||
      window.location.href.startsWith("https://uatilms.mhada.gov.in/") ||
      window.location.href.startsWith("https://housing.pmrda.gov.in/") ||
      window.location.href.startsWith("https://housing.chhsambhajinagarmc.org/") ||
      window.location.href.startsWith("http://localhost:8100/")
    ) {
      this.isDownloadAppButtonVisible = true;
    }

    localStorage.setItem("lastRoute", this.router.url);
    this.preLotteryApplicationService.fetchActiveNews().subscribe((news) => {
      this.news = news.filter((n) => n.announcementType === "ANNOUNCEMENT");
    });

    this.sharedService.name.subscribe((lang) => {
      this.lang = lang;
    });

    this.getLandingVideos();
    this.getBannerImages();
    this.loadGoLiveDate();
    // }

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const fragment = this.route.snapshot.fragment;
      if (fragment) {
        this.viewportScroller.scrollToAnchor(fragment);
      }
    }, 100); // Ensure the DOM is ready
  }

  slidePrev() {
    this.slides?.slidePrev();
    this.slidesXl?.slidePrev();
    this.videoSlides?.slidePrev();
  }

  slideNext() {
    this.slides?.slideNext();
    this.slidesXl?.slideNext();
    this.videoSlides?.slideNext();
  }

  slidePrevVideo() {
    this.videoSlidesLargeScreen?.slidePrev();
    this.videoSlides?.slidePrev();
  }

  slideNextVideo() {
    this.videoSlidesLargeScreen?.slideNext();
    this.videoSlides?.slideNext();
  }

  async getBannerImages() {
    this.banners = [];
    const response: any = await this.questionAnswerService.getBannerImages();
    if (response.status === 'SUCCESS') {
      this.banners = response.bannerImages;
    }
  }

  async startNow() {
    if (this.authService.isAuthenticateUser()) {
      this.router.navigate(["/registration-step"], { replaceUrl: true });
    } else {
      this.router.navigate(["/signUp"], { replaceUrl: true });
      localStorage.removeItem("loginPan");
      localStorage.removeItem("otpResendTimeLeft");
      localStorage.removeItem("otpVerificationPending");
    }
  }

  displayImagePopup() {
    this.dialog.open(LandingPopupComponent, {
      disableClose: true,
      width: "600px",
    });
  }

  async getLandingVideos() {
    this.videos = [];
    const response: any = await this.authenticationService.getLandingVideos();
    for (let i = 0; i < response.length; i++) {
      const last = response[i]["lovMediaLink"].substring(
        response[i]["lovMediaLink"].lastIndexOf("/") + 1
      );
      this.videos.push({
        lovMediaLink: response[i]["lovMediaLink"],
        videoId: "https://img.youtube.com/vi/" + last + "/0.jpg",
      });
    }
  }

  viewHelpVideo(url: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.dialog.open(YoutubeHelpVideoComponent, {
      disableClose: true,
      panelClass: "video-dialog",
      data: { qsDescription: url, qsCode: "landing", pkQsid: -1 },
    });
  }

  checkActiveLanguage() {
    this.sharedService.name.subscribe((data) => {
      this.activeLangIndex = data === "mr" ? 1 : 0;
      setTimeout(() => {
        this.slides?.update();
      }, 200);
    });
  }

  bannerHeading(bannerHeading) {
    return bannerHeading?.split("|||")[this.activeLangIndex];
  }


  goLiveDate: Date | null = null;
isGoLiveLoaded: boolean = false;

// loadGoLiveDate() {
//   this.preLotteryApplicationService.getGoLiveDate().subscribe({
//     next: (res: any) => {
//       // If HttpResponse event, extract body
//       const value = res?.body ?? res;

//       console.log("Raw go-live parsed value:", value);

//       if (typeof value === 'string') {
//         this.goLiveDate = new Date(value.trim());
//         console.log("Final parsed goLiveDate =", this.goLiveDate);
//       }

//       this.isGoLiveLoaded = true;
//     },
//     error: (err) => {
//       console.error("Error fetching go-live date", err);
//       this.isGoLiveLoaded = true;
//     }
//   });
// }

loadGoLiveDate() {
  this.preLotteryApplicationService.getGoLiveDate().subscribe({
    next: (res: any) => {
      const value = res?.body ?? res;
      console.log("Raw go-live parsed value:", value);

      if (typeof value === 'string') {
        this.goLiveDate = new Date(value.trim());
        console.log("Final parsed goLiveDate =", this.goLiveDate);

        // ⭐ STORE DATE IN GLOBAL SERVICE FOR TOOLBAR
        this.goLiveService.setGoLiveDate(this.goLiveDate);
      }

      this.isGoLiveLoaded = true;
    },
    error: (err) => {
      console.error("Error fetching go-live date", err);
      this.isGoLiveLoaded = true;
    }
  });
}

get showPoster(): boolean {
  if (!this.goLiveDate) {
    console.log("showPoster → goLiveDate not loaded yet");
    return false;
  }

  const now = new Date();
  const result = now < this.goLiveDate;

  console.log(
    "showPoster() → now:", now,
    "goLive:", this.goLiveDate,
    "result:", result
  );

  return result;
}


}
